import React from "react";
import { useSelector } from "react-redux";
import { LANDSCAPE } from "../../../config/Constant";
import TabBar_Portrait from "./tabbar_portrait";
import TabBar_Landscape from "./tabbar_landscape";


export const TabBar = (props) => {

    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <TabBar_Landscape {...props} />;
    } else {
        return <TabBar_Portrait {...props} />;
    }

}